(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filter-presets"] && !Shopify.designMode) return;
  try {
    (function () {
    var sortOptions = document.querySelectorAll('.filter-presets__sort-option');
    sortOptions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.dataset.sort);
        window.location.href = url.href;
      });
    });

    document.addEventListener('click', function (e) {
      var details = document.getElementById('FilterPresetsSort');
      if (details && !details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
